<p-dialog header="{{ editIndex !== null ? ('fs.res.common.finance.researchContract.editIncomes' | hisUi) : ('fs.res.common.finance.researchContract.assignIncomes' | hisUi) }}" 
    [(visible)]="visibility" [modal]="true" height="auto" (onHide)="closeDialog()" [draggable]="false" [blockScroll]="true">

    <div class="layoutBlock">
        <div class="columnFullWidth">
            <his-plam>
	            <p-autoComplete #content 
	                [hisDdKey]="hisDdKeyPrefix + '.budgetSource.defaulttext'"
	                [dropdown]="true"
	                [(ngModel)]="researchContractIncome.budgetSourceName"
	                [suggestions]="filteredOptions"
	                [forceSelection]="true"
	                (completeMethod)="completeMethod($event)">
	            </p-autoComplete>
            </his-plam>
            
            <his-plam>
               <p-inputNumber #content class="p-inputnumber-input"
                    [hisDdKey]="hisDdKeyPrefix + '.year'" 
                    [(ngModel)]="researchContractIncome.year"
                    [maxlength]="4" [useGrouping]="false">
               </p-inputNumber>
            </his-plam>
            
            <his-plam>
                <p-inputNumber #content class="inputNumberWidth100"
                    [hisDdKey]="hisDdKeyPrefix + '.incomeAmount'" 
                    [(ngModel)]="researchContractIncome.incomeAmount" 
                    locale="{{hisBaseGlobalsService.getLanguage()}}"
                    mode="decimal" [minFractionDigits]="2">
                </p-inputNumber>
            </his-plam>
        </div>
    </div>
    
   <p-footer>
        <button (click)="applyChanges()" (keydown.tab)="$event.preventDefault(); $event.stopPropagation(); cancelBtn.focus();">
            <span>{{ 'common.apply' | hisUi }}</span>
        </button>
        <button #cancelBtn (click)="closeDialog()" (keydown.tab)="$event.stopPropagation();">
            <span>{{ 'common.cancel' | hisUi }}</span>
        </button>
    </p-footer>
</p-dialog>
